import React from "react";
import AssetAppealDetails from "./AssetAppealDetails";
import RespondBackSection from "pages/AssetRecovery/Descision/ReferralDecision/RespondBackSection";
import { AssetAppeal } from "types";

export default function AssetAppealDetailsContainer({
  appeal,
  fileRowProps,
  isAssetCoordinator,
  isAssetProsecutor,
  loading,
  setActiveTab,
  setAppeal,
}: {
  appeal?: AssetAppeal;
  fileRowProps: any;
  isAssetCoordinator: boolean;
  isAssetProsecutor: boolean;
  loading: boolean;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  setAppeal: React.Dispatch<React.SetStateAction<AssetAppeal | null>>;
}) {
  return (
    <div className="flex gap-3">
      <div className="w-3/5">
        <AssetAppealDetails
          appeal={appeal as AssetAppeal}
          isAssetCoordinator={isAssetCoordinator}
          isAssetProsecutor={isAssetProsecutor}
          loading={loading}
          setActiveTab={setActiveTab}
          setAppeal={setAppeal}
          fileRowProps={fileRowProps}
        />
      </div>
      <div className=" w-2/5">
        <RespondBackSection
          appealId={appeal?.id}
          fileRowProps={fileRowProps}
          referralId=""
          type="appeal"
        />
      </div>
    </div>
  );
}
